import React from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'

import { ChargePointContextProvider } from '../../../common/context/ChargePointContext'
import { useChargePointGetQuery } from '../../../common/redux/api/web-api'
import { Button } from '../../../lib/button'
import useText from '../../../common/hooks/useText'
import Text from '../../../ui/Text'
import { ChargePointCapiPage } from '../charge-point-capi-page'
import { ChargePointOcppPage } from '../charge-point-ocpp-page'
import { ChargePointPageControls } from '../../../common/features/charge-point-page-controls'

const SBackButtonWrapper = styled.div`
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
`

const SExternalChargerMessageWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
`

const SExternalChargerMessage = styled.div`
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
    text-align: center;
    width: 310px;
`

const SContainer = styled.div`
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    background-color: #ffffff;
    border: none;

    @media (min-width: 990px) {
        width: 90vw;
        max-width: 1400px;
    }
`

export function ChargePointPage(): React.ReactElement {
    const text = useText()
    const { chargePointId } = useParams()

    const { data: chargePoint, isLoading } = useChargePointGetQuery(
        {
            chargePointId,
            expand: 'additionalInfo,scheduleInfo',
        },
        {
            skip: !chargePointId,
        }
    )

    return (
        <SContainer>
            {chargePoint ? (
                <>
                    <ChargePointContextProvider>
                        <ChargePointPageControls chargePoint={chargePoint} />
                        {chargePoint?.ocppServerMode === 'None' && (
                            <ChargePointCapiPage chargePoint={chargePoint} isLoading={isLoading} />
                        )}
                        {chargePoint?.ocppServerMode === 'Internal' && (
                            <ChargePointOcppPage chargePoint={chargePoint} isLoading={isLoading} />
                        )}
                        {chargePoint?.ocppServerMode === 'External' && (
                            <div>
                                <SBackButtonWrapper>
                                    <Button title={text('btnBack')} onClick={() => window.history.back()} />
                                </SBackButtonWrapper>
                                <SExternalChargerMessageWrapper>
                                    <SExternalChargerMessage>
                                        <Text
                                            code="msgChargerIsDeployedToExternalPart"
                                            values={{ chargePointId: chargePoint.id }}
                                        />
                                    </SExternalChargerMessage>
                                </SExternalChargerMessageWrapper>
                            </div>
                        )}
                    </ChargePointContextProvider>
                </>
            ) : null}
        </SContainer>
    )
}
